module.exports = __webpack_public_path__ + "img/gartner-cool-vendor.3d7b802e.jpeg";